import { render, staticRenderFns } from "./OrdersFilterDialog.vue?vue&type=template&id=3f11b467"
import script from "./OrdersFilterDialog.vue?vue&type=script&lang=js"
export * from "./OrdersFilterDialog.vue?vue&type=script&lang=js"
import style0 from "./OrdersFilterDialog.vue?vue&type=style&index=0&id=3f11b467&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports